import { useAppSelector } from 'redux/store';
import { selectCurrentUser } from 'redux/reducers/auth';

export default function useCurrentAccount() {
  return useAppSelector(selectCurrentUser)?.currentAccount;
}
